module.exports = __webpack_public_path__ + "img/pn.d407e767.png";